/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdEmployeeDataMutationRequest,
  PutApiV1PersonIdEmployeeDataMutationResponse,
  PutApiV1PersonIdEmployeeDataPathParams,
  PutApiV1PersonIdEmployeeData400,
  PutApiV1PersonIdEmployeeData401,
  PutApiV1PersonIdEmployeeData404,
  PutApiV1PersonIdEmployeeData500,
} from "../../types/personEmployeeController/PutApiV1PersonIdEmployeeData.ts";

function getPutApiV1PersonIdEmployeeDataUrl(
  id: PutApiV1PersonIdEmployeeDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/employee-data` as const,
  };
  return res;
}

/**
 * @description Atualiza a aba Employee. Cria o vínculo caso ainda não exista. Todos os campos informados sobrescrevem os atuais. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de funcionário (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/employee-data}
 */
export async function putApiV1PersonIdEmployeeData(
  id: PutApiV1PersonIdEmployeeDataPathParams["id"],
  data?: PutApiV1PersonIdEmployeeDataMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1PersonIdEmployeeDataMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdEmployeeDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdEmployeeData400
      | PutApiV1PersonIdEmployeeData401
      | PutApiV1PersonIdEmployeeData404
      | PutApiV1PersonIdEmployeeData500
    >,
    PutApiV1PersonIdEmployeeDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdEmployeeDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
